import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo, useRef } from 'react';
const noopRegistry = {
    register: ()=>()=>{},
    refreshAll: ()=>Promise.resolve()
};
const RestfulRefreshRegistryContext = /*#__PURE__*/ createContext(noopRegistry);
export function RestfulRefreshRegistryProvider(param) {
    let { children } = param;
    const refreshersRef = useRef(new Set());
    const registry = useMemo(()=>({
            register (refresher) {
                refreshersRef.current.add(refresher);
                return ()=>{
                    refreshersRef.current.delete(refresher);
                };
            },
            refreshAll: ()=>Promise.allSettled([
                    ...refreshersRef.current
                ].map((refresh)=>refresh()))
        }), []);
    return /*#__PURE__*/ _jsx(RestfulRefreshRegistryContext.Provider, {
        value: registry,
        children: children
    });
}
export const useRestfulRefreshRegistry = ()=>useContext(RestfulRefreshRegistryContext);
